<template>
  <div class="bottom-navigation-container">
    <div class="container" v-if="this.$props.showModeNavigation">
       <div class="sticky-footer-mobile">
      <div class="fullscreen" @click="navigateToFullScreen" v-if="$store.state.common.isModeSwipe != true ">
        <span>Full</span>
        <span><i class="material-icons">zoom_out_map</i></span>
      </div>

      <div class="fullscreen" @click="navigateToListView" v-if="this.$props.isModeSwipe">
        <span>List</span>
        <span><i class="material-icons">reorder</i></span>
      </div>
      <div class="separator"></div>
      <div class="map-view" @click="navigateToMapView">
        <span><i class="material-icons">map</i></span>
         <span class="ml-2">Map</span>
      </div>
    </div>
    </div>
    <div class="sticky-footer-common hidden-md-and-up" id="user-footer">
      <!-- home page -->
      <a
        href="https://www.withaview.co/"
        class="footer-icons text-dark text-decoration-none"
      >
        <button>
          <img
            loading="lazy"
            height="16"
            class="wav-icon-footer"
            src="../../../static/img/vectorpaint.svg"
          />
        </button>
        <span>Home</span>
      </a>

      <!-- profile page: liked images tab -->
      <span
        @click="navigateToSaved"
        class="footer-icons text-dark text-decoration-none"
      >
        <button>
          <i class="material-icons">note_add</i>
        </button>
        <span>Travel List</span>
      </span>

      <!-- profile page -->
      <span
        @click="navigateToProfile"
        class="footer-icons user_account text-dark text-decoration-none"
      >
        <i
          class="material-icons"
          v-if="!this.$props.isLoggedIn && this.$props.screenW < 600"
          >account_circle</i
        >
        <i
          class="material-icons"
          v-if="!this.$props.isLoggedIn && this.$props.screenW > 600"
          >perm_identity</i
        >
        <img
          :src="this.$props.user.photoURL"
          v-if="isLoggedIn"
          style="height: 1.75rem; width: 1.75rem; border-radius: 100%"
        />
        <span>Me</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log("props", this.$props);
  },
  methods: {
    saveInLs() {
      let localStorageItem = {
        maxPhotos: this.$props.maxPhotos,
        swipeIndex: this.$props.swipeIndex,
        filteredImagesArr: this.$props.filteredImagesArr,
        isModeSwipe: this.$props.isModeSwipe,
        lastSelectedQuery: this.$props.lastSelectedQuery,
      };
      localStorage.setItem(
        this.$props.localStorageName,
        JSON.stringify(localStorageItem)
      );
    },
    navigateToProfile() {
      this.saveInLs();
      this.$props.isLoggedIn
        ? this.$router.push({
            path: "/profile",
            query: {
              profile_Id: this.$props.user.uid,
              selected_tab: "checkins",
            },
          })
        : this.$router.push(`/login`);
    },
    navigateToSaved() {
      this.$props.isLoggedIn
        ? this.$router.push({
            path: "/profile",
            query: {
              profile_Id: this.$props.user.uid,
              selected_tab: "likes",
            },
          })
        : this.$router.push(`/login`);
    },
    navigateToListView() {
      this.$props.setSwipeIndex();
      this.$store.state.common.isModeSwipe = false
    },
    navigateToFullScreen() {
      this.$store.state.common.isModeSwipe = true;
      this.$store.state.common.swichModesBG = false;
    },
    navigateToMapView() {
      this.saveInLs();
      this.$router.push({ path: `/map`, query: this.$route.query });
      this.$store.state.common.swichModesBG = false;
    },
  },
  props: {
    localStorageName: String,
    screenH: Number,
    screenW: Number,
    view: String,
    maxPhotos: Number,
    swipeIndex: Number,
    isModeSwipe: Boolean,
    filteredImagesArr: Array,
    lastSelectedQuery: String,
    isLoggedIn: Boolean,
    user: Object,
    setSwipeIndex : Function,
    showModeNavigation: Boolean
  },
};
</script>

<style lang="scss" scoped>
//imported styles
@import "../../assets/scss/common/bottomNavigation.scss";
</style>



// WEBPACK FOOTER //
// bottomNavigation.vue?13f266ba